const $inject = [];
const lbaTextArea = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaTextAreaCtrl',
    controllerAs: 'vm',
    template: require('./lbaTextArea.html')
  }
};

lbaTextArea.$inject = $inject;

export default lbaTextArea;



// WEBPACK FOOTER //
// ./src/components/lbaTextArea/lbaTextAreaDir.js